import Typography from "@mui/material/Typography";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as SearchInputIcon } from "../../assets/search-input-icon.svg";
import { ReactComponent as HugeIcon } from "../../assets/huge-icon.svg";
import { ReactComponent as GlossaryIllustration } from "../../assets/glossary-illustration.svg";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import GlossaryRoleList from "../../components/template/base-template/glossaryList/glossary-role-list";

import "./glosarry.scss";
import { KeyboardArrowDown } from "@mui/icons-material";
import { BoxGlossary } from "./glossary.styles";
import { useSelector } from "react-redux";
import { stateRelatedRoles } from "../../store/ducks/relatedRoles";
import Role from "../../utils/interfaces/IRole";
import { List } from "@mui/material";

const Glossary = () => {
    const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
    const options = [{ value: "all", label: "Selecionar todos" }, ...alphabet.map((letter) => ({ value: letter, label: letter }))];
    const { relatedRole } = useSelector(stateRelatedRoles);
    const [selectedOption, setSelectedOption] = useState<string>("all");
    const [searchRoleFilterInput, setSearchRoleFilterInput] = useState("");

    const sortRolesMemo = useMemo(() => {
        if (!relatedRole.nodes.length) return [];
        return relatedRole?.nodes.slice().sort((a, b) => a.role.localeCompare(b.role));
    }, [relatedRole]);

    useEffect(() => {
        if (relatedRole.nodes.length) {
            setFilteredRoles(sortRolesMemo);
        }
    }, [relatedRole, sortRolesMemo]);
    const [filteredRoles, setFilteredRoles] = useState<Role[]>(sortRolesMemo || []);

    const handleSelectedRoleOption = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;

        if (value == "all") {
            setFilteredRoles(sortRolesMemo || []);
        } else {
            const filtered = relatedRole?.nodes.filter(({ role }) => role.toLowerCase().startsWith(value.toLowerCase()));
            setFilteredRoles(filtered);
        }
        setSelectedOption(event.target.value);
    };

    const handleSearchRoleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const filtered = relatedRole?.nodes.filter(({ role }) => role.toLowerCase().includes(value.toLowerCase()));
        setFilteredRoles(filtered);
        setSearchRoleFilterInput(event.target.value);
    };

    return (
        <BoxGlossary paddingTop={10} paddingBottom={20}>
            <Box flexDirection={"row"} display={"flex"}>
                <Box>
                    <Typography
                        id="title-glossary"
                        fontWeight="700"
                        lineHeight="39.01px"
                        style={{
                            fontSize: "clamp(14px,8vw,40px)",
                        }}
                        color="#2B25B8"
                        fontFamily="IliaMontSerratBold"
                    >
                        Glossário
                    </Typography>

                    <Typography
                        id="subtitle-glossary"
                        component="p"
                        sx={{
                            fontFamily: "IliaOpenSans",
                            marginTop: "24px",
                            color: "#48495D",
                            fontSize: "clamp(14px,8vw,20px)",
                            fontWeight: "400",
                            maxWidth: "80%",
                        }}
                    >
                        O glossário apresenta todos os cargos da ília em ordem alfabética. Você pode refinar sua busca filtrando por letra inicial ou
                        utilizando o campo de pesquisa.
                    </Typography>
                    <Box className="inputsSearchDesktop" marginTop={"40px"} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                        <Box className="inputSearch">
                            <OutlinedInput
                                id="search-role"
                                placeholder="Pesquisar"
                                inputProps={{ style: { height: "20px", width: "80%", borderRadius: "8px", border: "1px", borderColor: "#E6E7F7" } }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <SearchInputIcon />
                                    </InputAdornment>
                                }
                                sx={{
                                    "&.MuiOutlinedInput-root": {
                                        width: "100%",
                                        borderRadius: "8px",
                                    },
                                }}
                                value={searchRoleFilterInput}
                                onChange={handleSearchRoleFilterInput}
                            />
                        </Box>
                        <Box className="selectSearch">
                            <Select
                                id="search-letter"
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            borderRadius: 8,
                                            marginTop: 10,
                                            msScrollbarTrackColor: "red",
                                            maxHeight: 200,
                                            background: "#E6E7F7",
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <HugeIcon />
                                    </InputAdornment>
                                }
                                IconComponent={KeyboardArrowDown}
                                value={selectedOption}
                                onChange={handleSelectedRoleOption}
                                style={{
                                    height: "53px",
                                }}
                                sx={{ borderRadius: "8px", ml: "20px", width: "100%" }}
                            >
                                {options.map((option) => (
                                    <MenuItem
                                        key={option.value}
                                        value={option.value}
                                        style={{
                                            paddingTop: 10,
                                        }}
                                    >
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>
                    </Box>
                </Box>

                <Box>
                    <GlossaryIllustration />
                </Box>
            </Box>
            <Box className="inputsSearch" display={"flex"} flexDirection={"row"} alignItems={"center"}>
                <Box className="inputSearch">
                    <OutlinedInput
                        id="search-role"
                        placeholder="Pesquisar"
                        inputProps={{ style: { height: "20px", width: "80%", borderRadius: "8px", border: "1px", borderColor: "#E6E7F7" } }}
                        startAdornment={
                            <InputAdornment position="start">
                                <SearchInputIcon />
                            </InputAdornment>
                        }
                        sx={{
                            "&.MuiOutlinedInput-root": {
                                width: "100%",
                                borderRadius: "8px",
                            },
                        }}
                        value={searchRoleFilterInput}
                        onChange={handleSearchRoleFilterInput}
                    />
                </Box>
                <Box className="selectSearch">
                    <Select
                        id="search-letter"
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    borderRadius: 8,
                                    marginTop: 10,
                                    msScrollbarTrackColor: "red",
                                    maxHeight: 200,
                                    background: "#E6E7F7",
                                },
                            },
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                        }}
                        startAdornment={
                            <InputAdornment position="start">
                                <HugeIcon />
                            </InputAdornment>
                        }
                        IconComponent={KeyboardArrowDown}
                        value={selectedOption}
                        onChange={handleSelectedRoleOption}
                        style={{
                            height: "53px",
                        }}
                        sx={{ borderRadius: "8px", ml: "20px", width: "100%" }}
                    >
                        {options.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                style={{
                                    paddingTop: 10,
                                }}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
            </Box>
            <Box sx={{ mt: "60px" }}>
                <List>
                    {filteredRoles.map((role, index) => (
                        <GlossaryRoleList item={role} key={role.role_id} />
                    ))}
                </List>
            </Box>
        </BoxGlossary>
    );
};

export default Glossary;
